/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type OrganizationTypeKind = 'foundation' | 'institute' | 'hospital' | 'research_center' | 'custom';

export const OrganizationTypeKind = {
    Foundation: 'foundation' as OrganizationTypeKind,
    Institute: 'institute' as OrganizationTypeKind,
    Hospital: 'hospital' as OrganizationTypeKind,
    ResearchCenter: 'research_center' as OrganizationTypeKind,
    Custom: 'custom' as OrganizationTypeKind
};